var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexagon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 172,
    viewBox: "0 0 305 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9911 -62.3458L22.0104 23.9896L33.9393 38.3939",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8252 50.4038L120.75 147.832",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.279 149.42L287.12 128.395L298.221 101.111",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.244 85.0344L334.326 8.72227",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4684 45.4763C48.0123 49.1196 45.4997 52.514 41.8564 53.0579C38.2131 53.6017 34.8187 51.0892 34.2748 47.4459C33.731 43.8026 36.2435 40.4082 39.8868 39.8643C43.5301 39.3204 46.9245 41.833 47.4684 45.4763ZM36.9561 47.0456C37.2789 49.2081 39.2937 50.6994 41.4561 50.3766C43.6186 50.0538 45.1099 48.039 44.7871 45.8766C44.4643 43.7141 42.4496 42.2228 40.2871 42.5456C38.1246 42.8684 36.6333 44.8831 36.9561 47.0456Z",
    fill: "#FF5148"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.261 149.27C147.805 152.914 145.293 156.308 141.649 156.852C138.006 157.396 134.612 154.883 134.068 151.24C133.524 147.597 136.036 144.202 139.68 143.658C143.323 143.114 146.717 145.627 147.261 149.27ZM136.749 150.84C137.072 153.002 139.087 154.493 141.249 154.171C143.412 153.848 144.903 151.833 144.58 149.671C144.257 147.508 142.243 146.017 140.08 146.34C137.918 146.662 136.426 148.677 136.749 150.84Z",
    fill: "#FF5148"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.845 88.7326C309.389 92.3759 306.877 95.7703 303.233 96.3142C299.59 96.8581 296.196 94.3455 295.652 90.7022C295.108 87.0589 297.62 83.6646 301.264 83.1207C304.907 82.5768 308.301 85.0893 308.845 88.7326ZM298.333 90.302C298.656 92.4644 300.671 93.9558 302.833 93.6329C304.996 93.3101 306.487 91.2954 306.164 89.1329C305.841 86.9704 303.827 85.4791 301.664 85.8019C299.502 86.1248 298.01 88.1395 298.333 90.302Z",
    fill: "#FF5148"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5921 -18.8172L56.9456 18.5933L84.3203 55.1503",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3972 67.8542L135.834 121.577L136.33 121.167L136.409 121.702L222.008 108.924L222.167 108.9L221.9 107.11L221.633 105.32L137.476 117.884L94.1862 65.5473L91.3972 67.8542Z",
    fill: "#FF5148"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.892 101.976L303.698 7.46322L300.325 6.14976L264.179 98.9673L237.457 102.957L237.991 106.536L266.499 102.281L266.426 101.795L266.892 101.976Z",
    fill: "#FF5148"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238.387 104.647C238.822 107.561 236.812 110.277 233.897 110.712C230.982 111.147 228.267 109.137 227.832 106.222C227.397 103.308 229.407 100.592 232.321 100.157C235.236 99.7219 237.952 101.732 238.387 104.647ZM229.977 105.902C230.235 107.632 231.847 108.825 233.577 108.567C235.307 108.309 236.5 106.697 236.242 104.967C235.983 103.237 234.372 102.044 232.642 102.302C230.912 102.56 229.719 104.172 229.977 105.902Z",
    fill: "#FF5148"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.185 -4.00872C311.621 -1.09408 309.611 1.62142 306.696 2.05654C303.781 2.49165 301.066 0.481602 300.631 -2.43303C300.196 -5.34767 302.206 -8.06318 305.12 -8.49829C308.035 -8.93341 310.75 -6.92335 311.185 -4.00872ZM302.776 -2.75325C303.034 -1.02328 304.646 0.169782 306.376 -0.0884782C308.106 -0.346739 309.299 -1.95852 309.04 -3.6885C308.782 -5.41847 307.17 -6.61154 305.44 -6.35328C303.71 -6.09501 302.517 -4.48323 302.776 -2.75325Z",
    fill: "#FF5148"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8252 50.4038L120.75 147.832",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.196 -21.98L88.961 14.1417L123.42 57.6815",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.192 65.9759L148.975 89.2606L182.769 85.3726",
    stroke: "#FF5148",
    strokeWidth: 3.6195
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.987 86.1831L245.496 77.4752L245.34 76.5569L246.133 76.8693L269.91 16.5364L269.954 16.4244L268.271 15.7608L266.587 15.0973L243.305 74.1748L193.383 82.6143L193.987 86.1831Z",
    fill: "#FF5148"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.187 -15.6013L241.545 -69.7084L238.651 -67.5346L278.334 -14.7047L270.988 3.93598L274.355 5.26307L282.274 -14.8301L281.543 -15.1178L282.187 -15.6013Z",
    fill: "#FF5148"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.528 58.332C133.27 59.4125 134.617 62.511 133.536 65.2527C132.456 67.9944 129.357 69.3411 126.616 68.2606C123.874 67.1801 122.527 64.0816 123.608 61.3399C124.688 58.5982 127.787 57.2515 130.528 58.332ZM127.411 66.2429C129.038 66.8842 130.877 66.0849 131.519 64.4575C132.16 62.8302 131.361 60.9911 129.733 60.3498C128.106 59.7084 126.267 60.5078 125.626 62.1351C124.984 63.7624 125.784 65.6015 127.411 66.2429Z",
    fill: "#FF5148"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M273.134 2.33593C275.876 3.41642 277.222 6.51493 276.142 9.25664C275.061 11.9983 271.963 13.345 269.221 12.2645C266.479 11.184 265.133 8.08551 266.213 5.34381C267.294 2.6021 270.392 1.25543 273.134 2.33593ZM270.016 10.2468C271.644 10.8881 273.483 10.0888 274.124 8.46145C274.765 6.83412 273.966 4.995 272.339 4.35368C270.711 3.71235 268.872 4.51166 268.231 6.139C267.59 7.76633 268.389 9.60544 270.016 10.2468Z",
    fill: "#FF5148"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.fbcfe44856b7cc07890ca8f90172ccbc.svg";
export { ForwardRef as ReactComponent };